import { Button } from '@flatfile/baseline'
import { Link } from 'react-router-dom'

export const UploadActions = () => {
  return (
    <Link to='/prepare-chat'>
      <Button variant='outline' icon='cross-large'>
        Cancel
      </Button>
    </Link>
  )
}
